import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  todoDropdown: {
    marginLeft: '4px'
  },
  deletePortfolioBtn: {
    padding: '4px 16px',
    '& div': {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left'
    }
  }
});
export default useStyles;